module.exports = __webpack_public_path__ + "img/shop-display.ad79e5f6.png";